import * as React from 'react';

// prettier-ignore
export const IconTrippleArrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.2 29.7" {...props}>
    <defs />
    <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" data-name="Gruppe 452">
      <path stroke="currentColor" d="M2 21l12.4 7.2h0l11.7-7h0" data-name="Pfad 640" />
      <path stroke="currentColor" opacity="0.66" d="M2 12l12.4 7.2h0l11.7-7h0" data-name="Pfad 641" />
      <path stroke="currentColor" opacity="0.33" d="M2 2l12.4 7.2h0l11.7-7h0" data-name="Pfad 642" />
    </g>
  </svg>
);
